var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08334 10C2.08334 6.08802 5.25465 2.91669 9.16668 2.91669C10.2983 2.91669 11.3668 3.18173 12.3146 3.65277C12.5207 3.75517 12.7708 3.67115 12.8732 3.46507C12.9755 3.259 12.8915 3.00892 12.6854 2.9065C11.625 2.37951 10.4298 2.08337 9.16666 2.08337C4.79439 2.08337 1.25 5.62779 1.25 10C1.25 14.3723 4.79441 17.9167 9.16666 17.9167C10.4298 17.9167 11.625 17.6205 12.6854 17.0935C12.8915 16.9911 12.9755 16.7411 12.8732 16.535C12.7707 16.329 12.5207 16.2449 12.3146 16.3473C11.3668 16.8183 10.2983 17.0834 9.16668 17.0834C5.25467 17.0834 2.08334 13.912 2.08334 10V10Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2946 6.37205C15.1319 6.20932 14.8681 6.20932 14.7053 6.37205C14.5426 6.53477 14.5426 6.79859 14.7053 6.96131L17.3274 9.58336H10.4167C10.1866 9.58336 10 9.76994 10 10C10 10.2301 10.1866 10.4167 10.4167 10.4167H17.3274L14.7053 13.0387C14.5426 13.2014 14.5426 13.4653 14.7053 13.628C14.8681 13.7907 15.1319 13.7907 15.2946 13.628L18.628 10.2947C18.667 10.2557 18.698 10.2093 18.7189 10.1582C18.7395 10.108 18.75 10.0543 18.75 10C18.7501 9.89391 18.7097 9.79178 18.6369 9.71459L18.6269 9.70434L15.2946 6.37205Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.5a1f1c035b903da05534876650e8fe3f.svg";
export { ForwardRef as ReactComponent };